import React, { useEffect } from 'react';
import Step1Overview from '../overview/step-1-overview';
import Step1MobileHeader from './step-1-mobile-header';
import Step1ProductsListDesktop from './products-list/step-1-products-list-desktop';
import Step1ProductsListMobile from './products-list/step-1-products-list-mobile';
import { useAppSelector } from '../../data/store';
import { sendGaCheckoutEvent } from '../../../../../domain/marketing/gtm-provider';
import { CartSteps } from '../../enums/cart-steps';
import SavedForLater from '../saved-for-later/saved-for-later';

/**
 * Shopping Cart Step #1.
 */
const CartStep1 = () => {

    const cartData = useAppSelector(store => store.root.cartData);
    // const [ showYouMayAlsoLike, setShowYouMayAlsoLike ] = useState(false);

    /**
     * https://wavesaudio.atlassian.net/browse/DSWEB-3348
     */
    useEffect(() => {
        sendGaCheckoutEvent(CartSteps.First, cartData);
    },
        // eslint-disable-next-line
        []
    );

    return (
        <>
            <Step1MobileHeader />

            <div className="flex flex-wrap w-full pb-10">

                <Step1ProductsListDesktop showYouMayAlsoLike={ false } />
                <Step1ProductsListMobile />

                <Step1Overview />
            </div>


            { /* mobile only - you may also like */ }
            {
                /*
                showYouMayAlsoLike &&
                <div className="w-full md:hidden mb-6">
                    <YouMayAlsoLike />
                </div>
                */
            }

            {
                /* mobile only - saved for later */
                cartData.wishListData && cartData.wishListData.length > 0 &&
                <div className="w-full md:hidden mb-6">
                    <SavedForLater />
                </div>
            }

        </>
    )
};

export default CartStep1;